import {html, css, LitElement} from 'lit';

export class DzSearchField extends LitElement {

    static get properties() {
        return {
            placeholder: { type: String }
        }
    }

    render() {
        return html`
            <input type="text" part="input" @input="${this.find}" placeholder="${this.placeholder}"/>
            <div part="reset" @click="${this.reset}">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M11.4062 1.54679L10.3448 0.485352L6.13672 4.69345L1.92862 0.485352L0.867188 1.54679L5.07528 5.75488L0.867188 9.96298L1.92862 11.0244L6.13672 6.81632L10.3448 11.0244L11.4062 9.96298L7.19815 5.75488L11.4062 1.54679Z" fill="black"/>
                </svg>
            </div>  
        `
    }

    reset() {
       this.renderRoot.querySelector("input").value = ``
       let evt = new CustomEvent("reset", {bubbles: true, composed: true})
       this.dispatchEvent(evt)
    }

    find(event) {
        let input = this.renderRoot.querySelector("input")
        if (input.value.length) {
            let evt = new CustomEvent("find", {bubbles: true, composed: true, detail: input.value})
            this.dispatchEvent(evt)
        } else {
            this.reset()
        }
    }
}

customElements.define('dz-search-field', DzSearchField)